/* eslint-disable react-hooks/exhaustive-deps */
import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';

const formatGtpStaticContent = (gtpStaticContent) => {
  if (gtpStaticContent?.description) {
    return JSON.parse(gtpStaticContent.description);
  }
};

const useGTPStaticData = (
  goalUID,
  isGTP,
  options = { selector: null, fallbackData: undefined }
) => {
  const key = `api/policies/gtp_${goalUID}`;
  const {
    data: gtpStaticContent,
    isValidating,
    isError,
    ...rest
  } = useFetch(
    isGTP && goalUID ? key : null,
    { useCamelCase: true, hostType: HOST_TYPE.CMS },
    { fallbackData: options.fallbackData }
  );

  if (options.selector && typeof options.selector === 'function')
    return options.selector(gtpStaticContent || {});
  return {
    key,
    gtpStaticContent:
      gtpStaticContent?.description && !isError
        ? formatGtpStaticContent(gtpStaticContent)
        : {},
    isValidating,
    ...rest
  };
};

export default useGTPStaticData;
